var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.4375C7.5875 28.4375 1.5625 22.4125 1.5625 15C1.5625 7.5875 7.5875 1.5625 15 1.5625C22.4125 1.5625 28.4375 7.5875 28.4375 15C28.4375 22.4125 22.4125 28.4375 15 28.4375ZM15 3.4375C8.625 3.4375 3.4375 8.625 3.4375 15C3.4375 21.375 8.625 26.5625 15 26.5625C21.375 26.5625 26.5625 21.375 26.5625 15C26.5625 8.625 21.375 3.4375 15 3.4375Z",
    fill: "#E47100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6383 19.9127C19.4758 19.9127 19.3133 19.8752 19.1633 19.7752L15.2883 17.4627C14.3258 16.8877 13.6133 15.6252 13.6133 14.5127V9.3877C13.6133 8.8752 14.0383 8.4502 14.5508 8.4502C15.0633 8.4502 15.4883 8.8752 15.4883 9.3877V14.5127C15.4883 14.9627 15.8633 15.6252 16.2508 15.8502L20.1258 18.1627C20.5758 18.4252 20.7133 19.0002 20.4508 19.4502C20.2633 19.7502 19.9508 19.9127 19.6383 19.9127Z",
    fill: "#E47100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI5);
export default __webpack_public_path__ + "static/media/i5.7ae8f6bc688a2b272ed873e7b3f61ec2.svg";
export { ForwardRef as ReactComponent };